// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"219":"a9d63013","649":"49531032","710":"ffc2e7a4","977":"e80259ca"}[chunkId] + ".chunk.css";
};